import * as React from 'react'
function SvgCurrencyLivres(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29 30H19v-6h6c1.2 0 2-.8 2-2s-.8-2-2-2h-6v-6c0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.2.8 2 2 2s2-.8 2-2c0-4.4-3.6-8-8-8s-8 3.6-8 8v6h-4c-1.2 0-2 .8-2 2s.8 2 2 2h4v6h-4c-1.2 0-2 .8-2 2s.8 2 2 2h18c1.2 0 2-.8 2-2s-.8-2-2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyLivres
